'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgChatCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M0 6c0 1.177.338 2.311.98 3.287-.21.238-.391.403-.54.498a.732.732 0 00.11 1.292c.248.105.562.167.94.167.391 0 .814-.068 1.26-.2C3.718 11.67 4.841 12 6 12c3.31 0 6-2.69 6-6S9.31 0 6 0 0 2.69 0 6zm4.071-1.929H7.93a.643.643 0 010 1.286H4.07a.643.643 0 010-1.286zm0 2.572h2.143a.643.643 0 010 1.286H4.071a.643.643 0 010-1.286z", id: "Chat-circle_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Chat-circle_svg__a" })))));
}

module.exports = SvgChatCircle;
//# sourceMappingURL=ChatCircle.js.map
